import { render, staticRenderFns } from "./banner_text.vue?vue&type=template&id=21b7e268&scoped=true&"
import script from "./banner_text.vue?vue&type=script&lang=js&"
export * from "./banner_text.vue?vue&type=script&lang=js&"
import style0 from "./banner_text.vue?vue&type=style&index=0&id=21b7e268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b7e268",
  null
  
)

export default component.exports